import { render, staticRenderFns } from "./UcRegisterVersions.yaml?vue&type=template&id=6e85b55c&component"
import script from "./UcRegisterVersions.yaml?vue&type=script&lang=ts&component"
export * from "./UcRegisterVersions.yaml?vue&type=script&lang=ts&component"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports